/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query CareersQuery($uid: String!) {
    prismic {
      careers(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_CareersBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_CareersBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_CareersBodyLeftslidingnavcontent {
          type
  label
  fields {
    content_subtitle
    content_title
    copy
    heading
    heading_color
    quote_author_details
    quote
    quote_author_image
    quote_author_name
    quote_author_details_2
    quote_2
    quote_author_image_2
    quote_author_name_2
    quote_author_details_3
    quote_3
    quote_author_image_3
    quote_author_name_3
    quote_author_details_4
    quote_4
    quote_author_image_4
    quote_author_name_4
    subheading
    subheading_color
  }
  primary {
    background_color
    background_image
    text_color
  }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Careers = ({ data, location }) =>
  data.prismic.careers ? (
    <MainLayout location={location} layout='careers'>
    <Helmet>
      <title>{(data.prismic.careers.title[0] && data.prismic.careers.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.careers.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.careers.path : 'https://www.digitalocean.com' + data.prismic.careers.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.careers.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.careers.title[0] ? data.prismic.careers.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.careers.description ? data.prismic.careers.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.careers.open_graph_image ? data.prismic.careers.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.careers.description ? data.prismic.careers.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.careers.title[0] ? data.prismic.careers.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.careers.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.careers.path : 'https://www.digitalocean.com' + data.prismic.careers.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.careers.open_graph_image ? data.prismic.careers.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.careers.body} />
    </MainLayout>
  ) : null;

Careers.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Careers;
